<template>
  <el-row class="container">
    <!-- <div class="left-container" :class="{'put-away': !show }">
      <transition name="fade">
        <div class="left-slot">
          <slot name="left"></slot>
        </div>
      </transition>
      <div class="gj-opt" v-if="showStowButton" @click="changeShow">
        <i class="opt-icon" :class=" show ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"></i>
        <div class="opt-text">{{ show ? "收起" : "展开" }}</div>
      </div>
    </div> -->
    <div class="left-container" v-show="show">
      <transition name="fade">
        <div class="left-slot">
          <slot name="left"></slot>
        </div>
      </transition>
    </div>
    <div class="gj-opt" v-if="showStowButton" @click="changeShow" :class="{'put-away': !show }">
      <i class="opt-icon" :class=" show ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"></i>
      <div class="opt-text">{{ show ? "收起" : "展开" }}</div>
    </div>
    <div class="right-container">
      <slot name="right"></slot>
    </div>
  </el-row>
</template>

<script>

  export default {
    name: "app-left-right-stow",
    props: {
      // 显示收起按钮
      showStowButton: {
        type: Boolean,
        default: false,
      }
    },
    computed: {},
    data() {
      return {
        show: true
      }
    },
    methods: {
      // 展开收起
      changeShow() {
        this.show = !this.show
        this.$emit('change', this.show)
      }
    }
  }
</script>

<style scoped lang="scss">
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
  .container {
    display: flex;
    height: 100%;
  }
  .left-container {
    width: 232px;
    background: #fff;
    position: relative;
    max-width: 300px;
    margin-left: 0;
    transition: margin-left .3s;
    &.put-away {
      margin-left: -252px;
    }
    .left-slot {
      position: relative;
      z-index: 101;
    }
  }
    .gj-opt {
      position: relative;
      width: 20px;
      height: 55px;
      z-index: 100;
      background: #F6F8FB;
      cursor: pointer;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      transform: translateY(250px);
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
      &.put-away {
          margin-left: -15px;
      }
      &::before {
        content: "";
        width: 3px;
        height: 100%;
        position: absolute;
        top: 0;
        left: -3px;
        background: #fff;
      }
      .opt-icon {
          color: #333;
          font-weight: 600;
          transform: scale(0.8);
          opacity: .8;
      }
      .opt-text {
        width: 1em;
        transform: scale(.9);
        color: #666;
      }
    }
  .right-container {
    flex: 1;
    overflow: hidden;
    margin-left: -7px;
  }
  .left-shadow {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  }
</style>
